import React from "react";

const PartnersTopNew = ({ partnersTopData = [] }) => {

    if (!partnersTopData.length) return null;

    return (
        <section className="md:bg-[#faf9ff] py-[30px]
            lg:py-[50px] max-sm:mb-10">
            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col gap-8 md:flex-row md:justify-center md:flex-wrap  lg:gap-[40px] xl:gap-[70px]">

                    {partnersTopData.map(({partners_top_select: {partners_top_status, partners_top_item}}, groupIndex) => (
                        <div className={`flex flex-col items-center md:flex-row md:justify-center md:gap-6 toppartner-new-${groupIndex} key=${groupIndex}`}>
                            {/* Название */}
                            <h3 className=" text-lg lg:text-xl uppercase">{partners_top_status}</h3>
                            {/* Лого */}
                            <div className="relative z-10">
                                {partners_top_item.map(
                                    ({ acf: { p_url, p_thumbnail, p_logo_width } }, partnerIndex) => (
                                        <a
                                            key={`${groupIndex}-${partnerIndex}`}
                                            href={p_url || '/'}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={p_thumbnail}
                                                alt={partners_top_status}
                                                className={groupIndex === 0 ? 'max-w-[170px]' : 'max-w-[140px]'}
                                            />
                                        </a>
                                    )
                                )}
                            </div>
                        </div>
                    ))}
                </div>
        </div>
        </section>
    );
};

export default PartnersTopNew;